module.exports = __webpack_public_path__ + "static/gongzi-fe145b4b690eaee6fa2ca4f55da03d12.png";